import { Component, OnInit } from '@angular/core';
import { SessionService } from '../../../services';
import { UscBiService } from '../../../services/usc-bi/usc-bi.service';

@Component({
    selector: 'sn-usc-bi-header',
    templateUrl: './usc-bi-header.component.html',
    styleUrls: ['./usc-bi-header.component.css']
})
export class UscBiHeaderComponent implements OnInit {

    constructor(
        protected sessionService: SessionService,
        protected uscBiService: UscBiService,
    ) { }

    ngOnInit() {
        this.sessionService.log("Email Templates Loading:", new Date());
        this.uscBiService.loadEmailTemplates().subscribe(
          data => { this.sessionService.log("Email Templates Loaded", new Date()) },
          err => { this.sessionService.log(err) }
        )
    }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-bi/usc-bi-header/usc-bi-header.component.ts